import { createErrorHandbook, type ErrorsHandbook, ErrorsHandbookBuilder } from '@/6_shared/api'

export const configurationErrorsHandbook: ErrorsHandbook = createErrorHandbook({
  ...new ErrorsHandbookBuilder(404).withErrorCode(1, 'Партнер не найден').build()
})
